import { createStyles, makeStyles, Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    selection: {
      padding: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column',
    },
    files: {
      marginTop: theme.spacing(1),
    },
    alertContainer: {
      width: '100%',
    },
    loading: {
      marginTop: theme.spacing(1),
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    fasttrack: {
      marginTop: '5%',
      marginLeft: '10%',
      marginRight: '10%',
      marginBottom: '5%',
      display: 'flex',
      justifyContent: 'space-between',
    },
    wrapper: {
      margin: '50px',
      width: '50%', // Ensures SelectionForm takes exactly 50%
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'right', // Centers content inside SelectionForm
      alignItems: 'right',
    },
    header: {
      textAlign: 'center',
      marginBottom: theme.spacing(1),
      color: theme.palette.text.primary,
      fontWeight: 'bold',
    },
    downloadLink: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      fontWeight: 'bold',
      cursor: 'pointer',
      transition: 'color 0.2s ease-in-out',
      '&:hover': {
        color: theme.palette.primary.dark,
        textDecoration: 'underline',
      },
    },
  }),
)
